<script>
    export default {
        props: {
            href: {
                type: String,
                default: '',
            },
            title: {
                type: String,
                default: '',
            },
            blank: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                active: false,
            }
        },
    }
</script>
<template>
    <span>
        <a v-if="blank" :href="'#'+href" :title="title" target="_blank">
            <slot></slot>
        </a>
        <router-link v-else :to="href" :title="title">
            <slot></slot>
        </router-link>
    </span>
</template>
<style lang="scss">
    .mag-link {
        text-decoration: none;
        &--disabled {
            pointer-events: none;
            cursor: no-drop;
        }
    }
</style>
